import React from "react";
import { error_check_fn, ORGANIZATION_ID, SERVER_BASE_URL } from "../../utils";
import axios from "axios";
import _ from "lodash";
import { LoadingOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import { message } from "antd";
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const AdminButton = ({
  data,
  error,
  setError,
  setRedbox,
  btnLoading,
  setBtnLoading,
}) => {
  const next = async () => {
    setRedbox(false);
    setBtnLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 0));

    let application_id = window.sessionStorage.getItem("application_id");

    let required_fields = [
      "legal_name_of_brokage",
      "ho_street",
      "ho_city",
      "ho_province",
      "ho_country",
      "pl_first_name",
      "pl_last_name",
      "pl_title",
      "cra_first_name",
      "cra_last_name",
      "cra_title",
      "acc_first_name",
      "acc_last_name",
      "acc_title",
      "eo_insurer",
      "eo_policy",
      "eo_limit",
      "cyber_insurer",
      "cyber_limit",
      "has_eando_claims_in_last_5years",
      "any_licensce_suspended",
      "brokerage_reprimanded_in_5years",
      "first_name",
      "last_name",
      "title",
    ];

    if (!data?.eo_expiry_date) {
      required_fields.push("eo_expiry_date");
    }
    if (data?.has_eando_claims_in_last_5years === "Yes") {
      required_fields.push("eando_claim_details");
    }

    if (data?.any_licensce_suspended === "Yes") {
      required_fields.push("suspended_details");
    }
    if (data?.brokerage_reprimanded_in_5years === "Yes") {
      required_fields.push("reprimand_details");
    }

    if (!data?.date) {
      required_fields.push("date");
    }

    let required_subform = ["contracts", "user_accounts", "licensing"];

    if (!data?.is_ho_the_branch) {
      required_subform.push("list_of_branches");
    }

    if (!data?.no_mga) {
      required_subform.push("mga");
    }

    // let is_valid = error_check_fn({
    //   required_fields: required_fields,
    //   required_subform: required_subform,
    //   required_checkbox: ["consent_forward", "terms_agreed"],
    //   required_email: [
    //     "general_email",
    //     "pl_email",
    //     "cra_email",
    //     "acc_email",
    //     "marketing_email",
    //     "product_training_email",
    //   ],
    //   required_phone: ["ho_phone_number", "cra_phone", "pl_phone", "acc_phone"],
    //   required_pc: ["ho_pc"],
    //   data,
    //   error,
    //   setError,
    // });

    // if (!is_valid) {
    //   setRedbox(true);
    //   setBtnLoading(false);

    //   return;
    // }

    let contracts = data?.contracts.some((item) => item?.company_name)
      ? data?.contracts.map((item) => {
          return {
            ...item,
            date_appointed: item?.date_appointed
              ? dayjs(item?.date_appointed).format("DD-MMM-YYYY")
              : "",
          };
        })
      : [];

    let licensing = data?.licensing.some(
      (item) => item?.province && item?.license
    )
      ? data?.licensing.map((item) => {
          return {
            ...item,
            expiry_date: item?.expiry_date
              ? dayjs(item?.expiry_date).format("DD-MMM-YYYY")
              : "",
          };
        })
      : [];

    await axios
      .post(`${SERVER_BASE_URL}/application/update_application`, {
        server_id: application_id,
        updates: {
          organization_id: ORGANIZATION_ID,
          registration: data?.register_as,
          general_email: data?.general_email,
          legal_name_of_brokerage: data?.legal_name_of_brokage,
          operating_name: data?.operating_name,
          head_office_phone: data?.ho_phone_number,
          head_office_street: data?.ho_street,
          head_office_line2: data?.ho_line2,
          head_office_country: data?.ho_country,
          head_office_province: data?.ho_province,
          head_office_city: data?.ho_city,
          head_office_pc: data?.ho_pc,
          branch_details: data?.list_of_branches?.some(
            (item) => item?.branch_name
          )
            ? data?.list_of_branches
            : [],
          contracts: contracts,
          mga: data?.mga.some((item) => item?.mga_name) ? data?.mga : [],
          personal_line_first_name: data?.pl_first_name,
          personal_line_last_name: data?.pl_last_name,
          personal_line_title: data?.pl_title,
          personal_line_email: data?.pl_email,
          personal_line_phone: data?.pl_phone,
          cra_first_name: data?.cra_first_name,
          cra_last_name: data?.cra_last_name,
          cra_title: data?.cra_title,
          cra_email: data?.cra_email,
          cra_phone: data?.cra_phone,
          accounting_first_name: data?.acc_first_name,
          accounting_last_name: data?.acc_last_name,
          accounting_title: data?.acc_title,
          accounting_email: data?.acc_email,
          accounting_phone: data?.acc_phone,
          marketing_email: data?.marketing_email,
          product_training_email: data?.product_training_email,
          agree_to_sending_email: data?.consent_forward,
          user_accounts: data?.user_accounts.some((item) => item?.first_name)
            ? data?.user_accounts
            : [],
          e_and_o_insurer: data?.eo_insurer,
          e_and_o_policy: data?.eo_policy,
          e_and_o_policy_limit: data?.eo_limit,
          e_and_o_expiry_date: data?.eo_expiry_date
            ? dayjs(data?.eo_expiry_date).format("DD-MMM-YYYY")
            : "",
          any_e_and_o_claims_in_5years:
            data?.has_eando_claims_in_last_5years === "Yes"
              ? true
              : data?.has_eando_claims_in_last_5years === "No"
              ? false
              : null,
          e_and_o_claims_details: data?.eando_claim_details,
          cyber_insurer: data?.cyber_insurer,
          cyber_limit: data?.cyber_limit,
          licensing: licensing,
          any_license_suspended:
            data?.any_licensce_suspended === "Yes"
              ? true
              : data?.any_licensce_suspended === "No"
              ? false
              : null,
          suspended_license_details: data?.suspended_details,
          is_brokerage_reprimanded_5years:
            data?.brokerage_reprimanded_in_5years === "Yes"
              ? true
              : data?.brokerage_reprimanded_in_5years === "No"
              ? false
              : null,
          reprimaned_details: data?.reprimand_details,
          first_name: data?.first_name,
          last_name: data?.last_name,
          title: data?.title,
          date: data?.date ? dayjs(data?.date).format("DD-MMM-YYYY") : "",
          agree_to_acknowledgement: data?.terms_agreed,
          progress: 100,
          edited_by_admin: true,
        },
      })
      .then((response) => {
        console.log(response);

        if (response.data.success) {
          application_id = response.data?.data?.server_id;
          window.sessionStorage.setItem("application_id", application_id);
          window.sessionStorage.setItem(
            "application_number",
            response.data?.data?.application_number
          );

          message.success("Application submitted successfully!");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    window.scrollTo(0, 0);

    setRedbox(false);
    setBtnLoading(false);
  };

  return (
    <div className="quote_btns">
      <button
        className="next_btn"
        style={{ margin: "auto" }}
        onClick={next}
        disabled={btnLoading}
      >
        submit Application
        {btnLoading ? <LoadingOutlined /> : ""}
      </button>
    </div>
  );
};

export default AdminButton;
